import { render, staticRenderFns } from "./TrainingPanel.vue?vue&type=template&id=f0a1074c&scoped=true"
import script from "./TrainingPanel.vue?vue&type=script&lang=js"
export * from "./TrainingPanel.vue?vue&type=script&lang=js"
import style0 from "./TrainingPanel.vue?vue&type=style&index=0&id=f0a1074c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a1074c",
  null
  
)

export default component.exports